import { Grid, Typography } from '@mui/material';
import React from 'react'
import { thousandSeparator } from '../../../../../../utils/constants';
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";

interface CatalogOrderProductRowProps {
    productName: string,
    productImage: string,
    attributes: string | null,
    quantity: number,
    currency: string,
    unitPrice: number,
    lineTotal: number,
    showQtyPriceBreakdown?: boolean
} 

const CatalogOrderProductRow: React.FC<CatalogOrderProductRowProps> = (props) => {
    
    const { productName, productImage, attributes, quantity, currency, unitPrice, lineTotal, showQtyPriceBreakdown } = props;
    
    return (
        <>
            <Grid container className={styles.catalogOrderProductRow} flexWrap="nowrap" alignItems="center">
                <Grid item className={styles.catalogOrderProductImageGrid}>
                    {productImage ? (
                        <a
                            href={productImage}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.catalogOrderProductImageLink}
                        >
                            <img src={productImage} alt={productName} className={styles.catalogOrderProductImage} />
                        </a>
                    ) : (
                        <div className={styles.catalogOrderProductImagePlaceholder} />
                    )}
                </Grid>
                <Grid item className={styles.catalogOrderProductDetails}>
                    <Typography className={styles.catalogOrderProductName}>{productName}</Typography>
                    {attributes && (
                        <Typography className={styles.catalogOrderProductAttributes}>{attributes}</Typography>
                    )}
                    {showQtyPriceBreakdown ? (
                        <Typography className={styles.catalogOrderProductQty}>
                            {`Qty ${quantity} × ${currency} ${thousandSeparator(unitPrice)}`}
                        </Typography>
                    ) : (
                        <Typography className={styles.catalogOrderProductQty}>{`Qty ${quantity}`}</Typography>
                    )}
                </Grid>
                <Grid item className={styles.catalogOrderProductPrice}>
                    <Typography className={styles.catalogOrderProductPriceText}>
                        {`${currency} ${thousandSeparator(lineTotal)}`}
                    </Typography>
                </Grid>
            </Grid>
        </>
    )
}

export default CatalogOrderProductRow
